import React from 'react';
import List from '@mui/material/List';
import isNil from '~/_base/functions/isNil';
import moment from 'moment';
import { ILoader, ILocation } from '~/_base/components/helixIcons';
import getTransactionSubtype from '../functions/getTransactionSubtype';
import { LocalisationTimeFormats } from '~/_base/help/localisationHelper';

export default class Feed extends React.Component {
  constructor(props) {
    super();

    this.state = {
      geoOnly: false,
      sortUp: false,
      filteredData: [],
    };
  }

  componentDidUpdate(prevProps) {
    // console.log('FEED DATA PROPS', this.props)
    if (this.props.getting && !prevProps.getting) {
      document.getElementsByClassName('feedData')[0].scrollTop = 0;
    }

    if (!isNil(this.props.feedDataSelectedIndex) && this.props.feedDataSelectedIndex !== prevProps.feedDataSelectedIndex) {
      setTimeout(() => {
        const topPos = document.getElementById(
          `live_feed_item_${this.props.feedDataSelectedIndex}`
        ).offsetTop;
        document.getElementsByClassName('feedData')[0].scrollTop = topPos - 100;
      }, 0);
    }
  }

  render() {
    const gettingDataClassName = this.props.getting
      ? 'gettingFeedData getting'
      : 'gettingFeedData';

    return (
      <div className="feedData">
        <div className={gettingDataClassName}>
          <ILoader fontSize="large" />
        </div>

        {this.props.data.length > 0 ? (
          <div>{this.generateList(this.props.data)}</div>
        ) : (
          <div>
            {!this.props.getting ? (
              <div className="feedItem noMatches">
                <h3>Nothing could be found.</h3>
                <h4>Change the time range to see something.</h4>
              </div>
            ) : null}
          </div>
        )}
      </div>
    );
  }

  handleFilter() {
    this.setState({
      geoOnly: !this.state.geoOnly,
    });
  }

  generateList(data) {
    if (isNil(data)) {
      return [];
    }

    data.sort((a, b) => {
      return moment(b.updated_at) - moment(a.updated_at);
    });

    const arr = data.map((event, index) => {
      let subTypeClass = getTransactionSubtype(event.subtype);
      const hasLocationClass = event.has_location === true ? 'haslocation' : '';
      const className = event._selected
        ? `feedItem ${subTypeClass} ${hasLocationClass}`
        : `feedItem ${hasLocationClass}`;

      return (
        <div
          id={`live_feed_item_${index}`}
          key={index}
          className={className}
          onClick={() => this.handleDataItemClick(event)}
        >
          <h3>
            <a href={event.href}>{`${moment(event.updated_at).format(
              LocalisationTimeFormats().dby_hm
            )}`}</a>
          </h3>
          <h4>{event.news_feed_message}</h4>
          {/* <h3>{`${moment(feature.properties.timestamp).format('DD MMM YYYY HH:mm')}`}</h3>
                    <h4>{`${feature.properties.type} - ${feature.properties.subtype}`}</h4>
                    <p>{`${feature.properties.name}`}</p> */}
          <div className={`indicator ${subTypeClass}`} />
          {event.has_location ? (
            <div className="iconIndicator">
              <ILocation />
            </div>
          ) : null}
        </div>
      );
    });

    arr.push(
      <div key={'last_item_key'} className="feedItem thatsall">
        <h3>That's all there is.</h3>
        <h4>Change the time range to see more or less.</h4>
      </div>
    );

    return <List dense={true}>{arr}</List>;
  }

  handleDataItemClick(feature) {
    if (typeof google == undefined) {
      return;
    }

    if (!feature.has_location) {
      return;
    }

    // this function is added to the global scope in the featureMap.js component
    showMapInfoWindow(feature.id);
    this.props.actions.selectFeature(feature.id);
  }
}
